import {
  TenantUsecaseInterface,
  UpdateStatusParams,
  DeleteLogoParams,
  PatchIntroVideoParams,
} from "./usecase.d";
import { TenantRepository } from "../../services/Tenant/tenant.repository";
import * as TenantReducer from "./reducer";
import { ActionType } from "./types";
import { CreateTenantDto } from "../../services/Tenant/dto/create.dto";
import { UpdateTenantDto } from "../../services/Tenant/dto/update.dto";
import {
  GetListParams,
  GetParams,
} from "../../services/Tenant/tenant.repository.d";

export class TenantUsecase implements TenantUsecaseInterface {
  dispatch?: TenantReducer.TenantDispatch;
  repository: TenantRepository;

  constructor(dispatch?: TenantReducer.TenantDispatch) {
    this.repository = new TenantRepository();
    this.dispatch = dispatch;
  }

  async get(params: GetParams) {
    const response = await this.repository.get(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.GetDetail,
        detailItem: response,
      });
    }

    return response;
  }

  async getList(params: GetListParams) {
    const response = await this.repository.getList(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.GetList,
        items: response,
      });
    }
  }

  async create(params: CreateTenantDto) {
    const response = await this.repository.create(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Create,
        addedItem: response.data,
      });
    }
  }

  async update(params: UpdateTenantDto) {
    const response = await this.repository.update(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Update,
        updatedItem: response.data,
      });
    }
    return response.data;
  }

  async updateStatus(params: UpdateStatusParams) {
    if (this.dispatch) {
      this.dispatch({
        type: ActionType.UpdateStatus,
        updatedStatusItem: params,
      });
    }

    try {
      await this.repository.update({
        id: params.id,
        isActive: params.isActive,
      });
    } catch (error) {
      if (this.dispatch) {
        this.dispatch({
          type: ActionType.UpdateStatus,
          updatedStatusItem: {
            id: params.id,
            isActive: !params.isActive,
          },
        });
      }
      throw error;
    }
  }

  async deleteLogo(params: DeleteLogoParams) {
    const response = await this.repository.deleteLogo(params);
    if (this.dispatch) {
      this.dispatch({
        type: ActionType.DeleteLogo,
      });
    }
    return response.data;
  }

  async patchIntroVideo(params: PatchIntroVideoParams) {
    const { tenantId, introVideoS3Key } = params;
    const response = await this.repository.patchIntroVideo({
      tenantId,
      introVideoS3Key,
    });
    if (this.dispatch) {
      this.dispatch({
        type: ActionType.PatchIntroVideo,
        patchIntroVideo: {
          tenantIntroVideoUrl: response.tenantIntroVideoUrl,
        },
      });
    }
    return response;
  }
}
